import { useState, useEffect } from 'react'

const EditContentSetting = ({isVisible, setting, setIsVisible, language, contentSettings, setContentSettings}) => {

    const [settingName, setSettingName] = useState('')
    const [settingType, setSettingType] = useState('')
    const [settingAlias, setSettingAlias] = useState('')
    const [defaultValue, setDefaultValue] = useState('')
    const [settingDescription, setSettingDescription] = useState('')
    const [showDescription, setShowDescription] = useState(false)
    const [settingId, setSettingId] = useState(0)
    const [contentModelId, setContentModelId] = useState(0)
    
    useEffect(() => {
        if(setting){
            setSettingName(setting.settingName)
            setSettingType(setting.settingType)
            setSettingAlias(setting.settingAlias)
            setDefaultValue(setting.defaultValue)
            setSettingDescription(setting.settingDescription)
            setShowDescription(setting.showDescription)
            setSettingId(setting.id)
            setContentModelId(setting.contentModelId)
        }
    },[isVisible])

    const handleClose = async e => {
        setSettingName('')
        setSettingType('')
        setSettingAlias('')
        setSettingId(0)
        setIsVisible(isVisible ? false : true)
    }

    const postContentSetting = async () => {

        var graphql = JSON.stringify({
            query: `mutation ($settingId: Long
                            , $contentModelId: Long
                            , $defaultValue: String
                            , $settingAlias: String
                            , $settingDescription: String
                            , $settingName: String
                            , $settingType: String
                            , $showDescription: Boolean){
                        putContentSetting(settingId:$settingId
                                        , contentModelId:$contentModelId
                                        , defaultValue:$defaultValue
                                        , settingAlias:$settingAlias
                                        , settingDescription:$settingDescription
                                        , settingName:$settingName
                                        , settingType:$settingType
                                        , showDescription:$showDescription) {
                            id
                            contentModelId
                            settingAlias
                            settingName
                            settingType
                            defaultValue
                            settingDescription
                            showDescription
                            sortOrder
                        }
                    }`,
            variables: {
                "settingId": settingId
                ,"contentModelId": contentModelId
                ,"defaultValue": defaultValue
                ,"settingAlias": settingAlias
                ,"settingDescription": settingDescription
                ,"settingName": settingName
                ,"settingType": settingType
                ,"showDescription": showDescription
            }
            
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {
            var resultData = JSON.parse(result).data
            console.log(resultData.putContentSetting)
            const updateList = contentSettings.map((item) => {
                if (item.id === resultData.putContentSetting.id) {
                    return resultData.putContentSetting;
                }
                return item;
            });
            setContentSettings(updateList)
            handleClose()
            return resultData
        })
        .catch(error => console.log('error', error))
        const data = await res
        
        return data

    }

    const handleSave = async e => {
        e.preventDefault();
        var error = false
        if(settingName === ""){
            error = true
        }
        if(settingId === 0){
            error = true
        }
        if(!error){
            await postContentSetting()
        }
    }

    return (
        <>
        {(isVisible) && <div id="cc_overlay"></div>}
        <div id="cc_edit_setting" className={isVisible ? '' : 'hidden'} >
           <div className="close-container">
                <span className="result_response"></span>
                <button onClick={handleClose}><i className="sprite-icon icon-close"></i></button>
            </div>
            <h3>{language.value === 'DA' ? 'Rediger: ' : 'Edit: '} <span>{settingName}</span></h3>
            <div id="cc_article_container">
                <div id="articletype_list">
                    <label className="input_label">
                        <span>Type</span>
                        <input type="text" name="settingType" value={settingType} autoComplete="off" readOnly={true}/>
                    </label>                    
                    <label className="input_label">
                        <span>{language.value === 'DA' ? 'Navn' : 'Name'}</span>
                        <input type="text" name="settingName" value={settingName} onChange={ e => setSettingName(e.target.value)} autoComplete="off"/>
                    </label>                    
                    <label className="input_label">
                        <span>Alias</span>
                        <input type="text" name="settingAlias" value={settingAlias} onChange={ e => setSettingAlias(e.target.value)} autoComplete="off"/>
                    </label>                    
                    <label className="input_label">
                        <span>{language.value === 'DA' ? 'Standard værdi' : 'Default value'}</span>
                        <input type="text" name="defaultValue" value={defaultValue} onChange={ e => setDefaultValue(e.target.value)} autoComplete="off"/>
                    </label>                    
                    <label className="input_label">
                        <span>{language.value === 'DA' ? 'Beskrivelse' : 'Description'}</span>
                        <textarea name="settingDescription" value={settingDescription} onChange={ e => setSettingDescription(e.target.value)} autoComplete="off" />
                    </label>                    
                    <label className="input_label">
                        <span>{language.value === 'DA' ? 'Vis beskrivelse' : 'Show description'}</span>
                        <input type="checkbox" name="shopDescription" checked={showDescription} onChange={ e => setShowDescription(showDescription ? false : true) } />
                    </label>                    
                </div>                
                <div className="align_right">
                    <button className="cc-btn blue-gradient" onClick={handleSave}>{language.value === 'DA' ? 'GEM' : 'SAVE'}</button>
                </div>
            </div>
        </div>
        </>
    )
}

export default EditContentSetting
